import { render, staticRenderFns } from "./TextSelector.vue?vue&type=template&id=abaf5832&scoped=true&"
import script from "./TextSelector.vue?vue&type=script&lang=js&"
export * from "./TextSelector.vue?vue&type=script&lang=js&"
import style0 from "./TextSelector.vue?vue&type=style&index=0&id=abaf5832&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abaf5832",
  null
  
)

export default component.exports